{
  "basicTerms": {
    "selectedOfTotal": "已选择 {selected}/{total}",
    "search": "搜索",
    "summary": "摘要",
    "insights": "洞察",
    "help": "帮助",
    "expand": "展开",
    "collapse": "收起",
    "menu": "菜单",
    "account": "账户",
    "logout": "退出登录",
    "signIn": "登录",
    "days": "天 | 天",
    "phone": "电话",
    "subscribers": "订阅者 | 订阅者",
    "favorites": "收藏 | 收藏",
    "others": "其他 | 其他",
    "yes": "是",
    "no": "否",
    "locations": "位置 | 位置",
    "active": "活跃",
    "inactive": "未活跃",
    "all": "全部",
    "view": "查看",
    "language": "语言",
    "required": "必填",
    "timezone": "时区",
    "new": "新建",
    "open": "开放",
    "close": "关闭",
    "closed": "已关闭",
    "occupied": "已占用",
    "reserved": "已预留",
    "enabled": "已启用",
    "disabled": "已禁用",
    "enable": "启用",
    "disable": "禁用",
    "print": "打印",
    "download": "下载",
    "zoomIn": "放大",
    "zoomOut": "缩小",
    "previous": "上一步",
    "next": "下一步",
    "version": "版本",
    "setup": "设置",
    "caution": "注意",
    "notes": "备注 | 备注",
    "add": "添加",
    "remove": "移除",
    "duration": "时长",
    "link": "关联",
    "unlink": "取消关联",
    "to": "至",
    "success": "成功",
    "error": "错误",
    "info": "信息",
    "warning": "警告",
    "time": "时间",
    "saved": "已保存",
    "forms": "表单 | 表单",
    "is": "为",
    "only": "仅",
    "saving": "正在保存",
    "text": "文本",
    "zip": "zip",
    "spreadsheet": "电子表格",
    "image": "图片",
    "cloning": "正在复制",
    "clone": "复制",
    "added": "已添加",
    "removed": "已移除",
    "planned": "已计划",
    "unplanned": "未计划",
    "checkedIn": "已签到",
    "checkedOut": "已签出",
    "more": "更多",
    "okay": "好的",
    "reschedule": "改期",
    "results": "结果 | 结果",
    "none": "无",
    "pages": "页 | 页",
    "pageOfTotal": "第 {current} 页，共 {total} 页",
    "of": "/",
    "default": "默认",
    "soon": "即将推出",
    "grid": "网格",
    "list": "列表",
    "booked": "已预约",
    "arrivals": "到达 | 到达",
    "early": "提前",
    "late": "迟到",
    "onTime": "准时",
    "area": "区域 | 区域",
    "spot": "车位",
    "single": "单个",
    "multiple": "多个",
    "filter": "筛选",
    "board": "看板",
    "at": "于",
    "from": "从",
    "recent": "最近",
    "delivered": "已送达",
    "sent": "已发送",
    "failed": "失败",
    "create": "创建",
    "tasks": "任务 | 任务",
    "emails": "电子邮件 | 电子邮件",
    "passwords": "密码 | 密码",
    "limits": "限制",
    "assignee": "负责人",
    "comment": "评论",
    "issue": "问题",
    "urgent": "紧急",
    "retry": "重试",
    "custom": "自定义",
    "na": "不适用"
  },
  "phrases": {
    "updateEmail": "更新电子邮件",
    "copyToClipboard": "复制到剪贴板",
    "copiedToClipboard": "已复制到剪贴板",
    "warehouseAddress": "仓库地址",
    "cloneSchedule": "复制时间表",
    "open24Hours": "24 小时营业",
    "featureEnabled": "功能已启用",
    "featureDisabled": "功能已禁用",
    "learnMore": "了解更多",
    "minuteLabel": "{minutes} 分钟",
    "minuteLabelFull": "{minutes} 分钟",
    "thisActionCannotBeUndone": "此操作无法撤销",
    "areYouSure": "您确定吗？",
    "unknownUser": "未知用户",
    "leaveWithoutSaving": "不保存并离开",
    "learnHowItWorks": "了解工作原理",
    "allFields": "所有字段",
    "selectColumns": "选择列",
    "selectedColumns": "已选列",
    "addFiles": "添加文件 | 添加文件",
    "tasks": "无任务 | {count} 个任务 | {count} 个任务",
    "driversSelfCheckin": "司机自助签到",
    "addReferenceNumber": "添加参考号",
    "myAccount": "我的账户"
  },
  "messages": {
    "theConfirmationFieldDoesNotSupportPasting": "确认字段不支持粘贴",
    "youMayHaveUnsavedChangesAreYouSureYouWantToLeaveThisPage": "您可能有未保存的更改，确定要离开此页面吗？",
    "browserDoesNotSupportCopyFunction": "浏览器不支持复制功能",
    "permissionToAccessClipboardWasDeniedToEnableAccessUpdateYourBrowserSettings": "访问剪贴板的权限被拒绝。如需启用访问，请更新您的浏览器设置。",
    "alternativelyYouCanManuallyCopy": "或者，您也可以手动复制",
    "areYouSureYouWantToLeaveYouMayHaveUnsavedChanges": "确定要离开吗？您可能有未保存的更改。",
    "noResultsFound": "未找到结果",
    "maximumOfReferenceNumbersAllowedCountRemoved": "最多允许 {maxItems} 个参考号。已移除 {removedCount} 个"
  },
  "fileFormats": {
    "jpeg": "jpeg",
    "jpg": "jpg",
    "png": "png",
    "webp": "webp",
    "pdf": "pdf"
  },
  "specialtyTerms": {
    "opendock": "Opendock",
    "warehouses": "仓库 | 仓库",
    "carrierContacts": "承运商联系人 | 承运商联系人",
    "loadTypes": "货物类型 | 货物类型",
    "docks": "站台 | 站台",
    "appointments": "预约 | 预约",
    "users": "用户 | 用户",
    "organizations": "组织 | 组织",
    "orgs": "组织 | 组织",
    "companies": "公司 | 公司",
    "referenceNumber": "参考号",
    "refNumber": "参考号",
    "status": "状态",
    "orgLoadTypes": "组织货物类型",
    "schedulingPortal": "预约门户",
    "customFields": "自定义字段 | 自定义字段",
    "interval": "间隔",
    "drivers": "司机 | 司机",
    "carriers": "承运商 | 承运商",
    "tags": "标签 | 标签",
    "yardManagement": "堆场管理",
    "carrier": "承运商 | 承运商",
    "assets": "资产 | 资产",
    "tvMode": "电视模式",
    "gridView": "网格视图",
    "listView": "列表视图",
    "gateManagement": "闸口管理",
    "selfCheckIn": "自助签到",
    "gateFeed": "闸口动态"
  },
  "appointmentStatuses": {
    "NoShow": "未到场",
    "Cancelled": "已取消",
    "Requested": "已申请",
    "Scheduled": "已预约",
    "Arrived": "已到达",
    "InProgress": "进行中",
    "Completed": "已完成",
    "Reserves": "预留"
  },
  "appointmentTypes": {
    "standard": "标准",
    "reserved": "已预留",
    "reserve": "预留"
  },
  "appointmentCreatorTypes": {
    "warehouseUser": "仓库用户",
    "carrier": "承运商"
  },
  "roles": {
    "base": "基础",
    "carrier": "承运商",
    "carrierAdmin": "承运商管理员",
    "spectator": "观察者",
    "attendant": "值守员",
    "operator": "操作员",
    "admin": "管理员",
    "owner": "所有者",
    "internal": "内部",
    "god": "超级用户"
  },
  "weekdays": {
    "sunday": "星期日",
    "monday": "星期一",
    "tuesday": "星期二",
    "wednesday": "星期三",
    "thursday": "星期四",
    "friday": "星期五",
    "saturday": "星期六"
  },
  "weekdaysAbbr": {
    "sun": "周日",
    "mon": "周一",
    "tue": "周二",
    "wed": "周三",
    "thu": "周四",
    "fri": "周五",
    "sat": "周六"
  },
  "buttons": {
    "nevermind": "算了",
    "select": "选择",
    "confirm": "确认",
    "next": "下一步",
    "previous": "上一步",
    "create": "创建",
    "edit": "编辑",
    "save": "保存",
    "send": "发送",
    "yesDelete": "是，删除",
    "skipCreation": "跳过创建",
    "cancel": "取消",
    "export": "导出",
    "saveChanges": "保存更改",
    "exportData": "导出数据",
    "resetToDefault": "恢复默认"
  },
  "tooltips": {
    "notAvailable": "不可用",
    "notAvailableForUserRole": "您的用户角色无法使用此功能。"
  },
  "errors": {
    "unkownError": "发生未知错误。",
    "thisFieldIsRequired": "此字段为必填项",
    "passwordDoesNotMeetRequirements": "密码不符合密码要求",
    "emailMustBeValid": "电子邮件必须有效",
    "pleaseEnterAValidPhoneNumber": "请输入有效的电话号码",
    "pleaseEnterAValidUrl": "请输入有效的 URL",
    "invalidHour": "小时无效",
    "invalidMinute": "分钟无效",
    "pleaseSelectAmOrPm": "请选择上午或下午",
    "pleaseEnterACompleteDateAndTime": "请输入完整的日期和时间",
    "mustBeANumber": "必须为数字",
    "mustBeAPositiveInteger": "必须为正整数",
    "mustBeAWholeNumber": "必须为整数",
    "isNotAValidNumber": "不是有效的数字",
    "isNotValid": "无效",
    "invalidUuid": "无效的 uuid",
    "dateMustNotBeInThePast": "日期不能早于今天",
    "mustBeWithin24HoursOfStartTime": "必须在开始时间的 24 小时之内",
    "pleaseSelectAtLeast": "请至少选择 {requiredCount} 个{itemName} | 请至少选择 {requiredCount} 个{itemName}",
    "cannotSelectMoreThan": "最多只能选择 {limit} 个{itemName} | 最多只能选择 {limit} 个{itemName}",
    "fieldMustEqual": "字段必须等于 {value}",
    "mustBeXCharacters": "必须为 {length} 个字符 | 必须为 {length} 个字符",
    "mustBeAtLeastXCharacters": "长度至少为 {min} 个字符 | 长度至少为 {min} 个字符",
    "mustBeAtMostXCharacters": "长度最多为 {max} 个字符 | 长度最多为 {max} 个字符",
    "mustBeBetweenXAndYCharactersLong": "长度必须介于 {min} 到 {max} 个字符之间",
    "mustBeNumberBetweenXAndY": "必须为介于 {min} 到 {max} 之间的数字",
    "mustBeNumberGreaterThan": "必须为大于或等于 {min} 的数字",
    "mustBeNumberLessThan": "必须为小于 {max} 的数字",
    "mustHaveAtLeast8Characters": "至少包含 8 个字符",
    "mustContainUpperCaseAndLowerCase": "必须包含大写和小写字母",
    "mustContainAtLeastOneLetter": "必须包含至少一个字母",
    "mustContainAtLeastOneSpecialCharacter": "必须包含至少一个特殊字符",
    "mustContainAtLeastOneNumber": "必须包含至少一个数字",
    "atLeastOneReferenceNumberIsRequired": "至少需要一个{refNumberDisplayName}",
    "mustBeAValidNumber": "必须为有效数字"
  },
  "warehouseAmenities": {
    "lumperServices": "装卸工服务",
    "overnightParking": "过夜停车",
    "driversRestroom": "司机洗手间",
    "freeWiFi": "免费 Wi-Fi"
  },
  "warehousePPERequirements": {
    "safetyBoots": "安全靴",
    "safetyGlasses": "护目镜",
    "gloves": "手套",
    "hardHat": "安全帽",
    "faceMask": "口罩",
    "noSmoking": "禁止吸烟",
    "longPants": "长裤",
    "longSleeves": "长袖",
    "highVisibilityVest": "高可见度反光背心",
    "hairAndBeardNet": "发网和胡须网"
  },
  "auditLog": {
    "header": "审计日志",
    "viewAuditLog": "查看审计日志",
    "noAuditLogEvents": "无审计日志事件",
    "printedOn": "打印于 {date}",
    "viewDetails": "查看详情",
    "snapshot": {
      "schedule": "日程",
      "eta": "预计到达时间",
      "emailSubscribers": "电子邮件订阅者",
      "customFields": "自定义字段",
      "statusTimes": "状态时间"
    },
    "timelineForAllUpdatesMadeToThis": "以下对象所有更新的时间线：",
    "hasTheWords": "包含以下字词",
    "eventsFromDate": "事件日期",
    "searchEvents": "搜索事件",
    "by": "操作人：",
    "appointmentUpdatesTimeline": "预约更新时间线：",
    "moreUpdates": "另有 {count} 条更新",
    "emailSubscribersUpdated": "电子邮件订阅者已更新",
    "detailsUpdated": "详情已更新",
    "recurrenceCreated": "已创建重复预约",
    "recurrenceDeleted": "已删除重复预约",
    "rescheduled": "{label}已改期",
    "etaUpdated": "预计到达时间已更新",
    "emailNotifications": "电子邮件通知",
    "carrierContactUpdated": "承运商联系人已更新",
    "reserveTransferred": "预留已转移",
    "tagsUpdated": "标签已更新",
    "scheduled": "{label}已预约",
    "statusUpdated": "状态已更新",
    "timeUpdated": "{arrived}时间已更新",
    "dwellTimeUpdated": "停留时间已更新",
    "labelWithStatus": "{label} {status}",
    "arrivedLate": "迟到 {duration}",
    "everyXAtXUntilX": "每{weekDays} {'@'} {endTime}，直至 {endDate}",
    "opendockTeam": "Opendock 团队",
    "unknownUser": "未知用户",
    "deleted": "已删除",
    "hasBeenCleared": "已清除",
    "actionUpdated": "已更新",
    "actionCreated": "已创建",
    "actionDeleted": "已删除",
    "noAction": "无操作",
    "emptyValue": "空值"
  },
  "timeline": {
    "createdTheTask": "创建了任务",
    "startedTheTask": "开始了任务",
    "blockedTheTask": "阻止了任务",
    "unblockedTheTask": "解除了任务阻止",
    "completedTheTask": "完成了任务",
    "cancelledTheTask": "取消了任务",
    "cancelledTheReserve": "取消了预留",
    "cancelledTheReservationForSpot": "取消了为此任务预留的 {areaName} - {spotCode}",
    "reservedSpotForThisTask": "为此任务预留了 {areaName} - {spotCode}",
    "reservedTheSpot": "预留了车位",
    "reason": "原因：{reason}",
    "addedA": "添加了",
    "reportedAn": "报告了",
    "clearedThe": "清除了",
    "flaggedTheTask": "标记了任务",
    "flaggedTheTaskAs": "将任务标记为",
    "unflaggedTheTask": "取消了任务标记",
    "unflaggedTheTaskAs": "取消了任务的标记：",
    "updatedTheTask": "更新了任务",
    "removedTask": "移除了任务",
    "attachments": "附件",
    "confirmedTheLocation": "确认了位置",
    "reportedAsMissing": "报告为缺失",
    "noActivityYet": "暂无活动",
    "noAssignee": "无负责人",
    "failedToFetchYardTaskTimeline": "获取堆场任务时间线失败",
    "failedToCreateComment": "创建评论失败"
  },
  "yardSpotStatusDialog": {
    "headers": {
      "actionThisSpot": "{action}此车位？"
    },
    "dropDownItems": {
      "cleaning": "清洁中",
      "underMaintenance": "维护中",
      "blockedByEquipment": "被设备阻挡",
      "safetyInspection": "安全检查",
      "routineInspection": "例行检查",
      "reserved": "已预留",
      "repairsNeeded": "需要维修",
      "damage": "损坏"
    },
    "labels": {
      "reason": "原因",
      "additionalNotes": "附加备注"
    },
    "placeholders": {
      "selectAReason": "选择原因",
      "enterAdditionalNotes": "输入附加备注"
    },
    "messages": {
      "thisSpotWillRemainUnavailable": "在重新设置为开放之前，此车位将无法分配资产。",
      "thisDoorWillBeSetAsOpen": "此门将被设置为开放，并可再次用于分配资产。",
      "assetInTransitClosingWillBlockMove": "资产 {assetCode} 目前正在前往此车位。关闭该车位将导致此次移动无法完成。"
    }
  },
  "tasks": {
    "presenter": {
      "unassigned": "未分配",
      "noDueDate": "无截止日期",
      "fromAnySpot": "从任意车位",
      "toAnySpot": "至任意车位",
      "anyAsset": "任意资产",
      "types": {
        "move": "移动"
      },
      "status": {
        "toDo": "待办",
        "inProgress": "进行中",
        "completed": "已完成",
        "canceled": "已取消"
      },
      "issue": "问题",
      "relatedEntity": {
        "spotArea": "区域",
        "spot": "车位",
        "asset": "资产"
      }
    }
  },
  "readyForPickupNotificationDialog": {
    "title": "待提货通知",
    "messages": {
      "body": "向以下联系人发送电子邮件，告知资产 {assetContainerCode} 已在 {warehouseName} 准备好待提货。",
      "notificationSent": "通知已成功发送。",
      "notificationFailed": "发送通知失败，请重试。"
    },
    "labels": {
      "notifyTheseContacts": "通知以下联系人：",
      "suggestedContacts": "建议联系人："
    },
    "buttons": {
      "skipNotification": "跳过通知"
    }
  },
  "chipList": {
    "keys": {
      "enter": "enter",
      "tab": "tab"
    },
    "messages": {
      "pressEnterOrTabToActionEntity": "按 {enterKey} 或 {tabKey} {action}{entity}",
      "pressEnterOrTabToAddEmail": "按 {enterKey} 或 {tabKey} 添加电子邮件"
    },
    "placeholders": {
      "emailSubscribers": "电子邮件订阅者"
    }
  }
}
